import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Phone, Lock, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, Field } from "./Login";

export default function Register() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords do not match."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { phone: phone.trim(), password, confirm_password: confirm });
      localStorage.setItem("vw_token", data.token);
      setUser(data.user);
      toast.success("Account created! Welcome to VirtualWin.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <h1 className="font-display text-3xl font-black text-white">Create your account</h1>
      <p className="mt-2 text-slate-400 text-sm">One account per phone number. No OTP — you're logged in instantly.</p>
      <form onSubmit={submit} className="mt-7 space-y-4">
        <Field icon={Phone} label="Phone number" value={phone} onChange={setPhone} placeholder="0244123456" testid="register-phone" />
        <Field icon={Lock} label="Password" type="password" value={password} onChange={setPassword} placeholder="••••••••" testid="register-password" />
        <Field icon={Lock} label="Confirm password" type="password" value={confirm} onChange={setConfirm} placeholder="••••••••" testid="register-confirm" />
        <button disabled={loading} className="vw-btn-primary w-full !py-3.5 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="register-submit">
          {loading ? "Creating…" : <>Create Account <ArrowRight size={18} /></>}
        </button>
      </form>
      <p className="mt-6 text-sm text-slate-400 text-center">
        Already have an account? <Link to="/login" className="text-emerald-400 font-semibold" data-testid="register-to-login-link">Login</Link>
      </p>
    </AuthShell>
  );
}
